import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import { fireActionTriggerCustomEvent } from '../events/pageEvents';

export const defaultClick = (page = {}) => {
  if (canUseDOM) {
    // Track to `events` array in the data layer
    const dataLayerEvents = get(window.digitalData, 'events', []);
    dataLayerEvents.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = dataLayerEvents;
    // Trigger custom event to notify Adobe Launch
    fireActionTriggerCustomEvent('default-click', {
      detail: page.data.eventObject
    });
  }

  // return for logging, adding to history, etc.
  return page;
};
defaultClick.eventType = 'DEFAULT_CLICK';

export const detectAdBlocker = (page = {}) => {
  if (canUseDOM) {
    // Track to `events` array in the data layer
    const dataLayerEvents = get(window.digitalData, 'events', []);
    dataLayerEvents.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = dataLayerEvents;

    // Trigger custom event to notify Adobe Launch
    fireActionTriggerCustomEvent('adblocker-detected', {
      detail: page.data.eventObject
    });
  }

  // return for logging, adding to history, etc.
  return page;
};
detectAdBlocker.eventType = 'DETECT_AD_BLOCKER';

export const newsletterSubmit = (page = {}) => {
  if (canUseDOM) {
    // Track to `event` array in the data layer
    const dataLayerEvents = get(window.digitalData, 'events', []);
    dataLayerEvents.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = dataLayerEvents;

    // Trigger custom event to notify Launch by Adobe
    fireActionTriggerCustomEvent('newsletter-submit', {
      detail: page.data.eventObject
    });
  }

  // return for logging, adding to history, etc.
  return page;
};
newsletterSubmit.eventType = 'NEWSLETTER_SUBMIT';

export const widgetImpression = (page = {}) => {
  // Note - see original concept for event history tracking example
  if (canUseDOM) {
    // Datalayer update not neccesary!
    // window.digitalData = merge({}, window.digitalData, page.data.eventObject);

    // Track as an EVENT in the data layer
    const dataLayerEvents = get(window.digitalData, 'events', []);
    dataLayerEvents.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = dataLayerEvents;
    // Trigger custom event to notify Adobe Launch
    fireActionTriggerCustomEvent('widget-impression', {
      detail: page.data.eventObject
    });
  }

  // return for logging, adding to history, etc.
  return page;
};
widgetImpression.eventType = 'WIDGET_IMPRESSION';
